import type { AxiosResponse } from "axios";
import Api from "api/Api";

export interface ApplicationWalletConfig {
  supportedChains: number[];
}

class WalletConfigAPI extends Api {
  static baseURL = `/v1/walletConfig`;

  static getSupportedChains = async (applicationId: string) => {
    try {
      const { data }: AxiosResponse<ApplicationWalletConfig> = await Api.get(
        `${WalletConfigAPI.baseURL}/${applicationId}`,
      );
      return data?.supportedChains || [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  static updateSupportedChains = ({
    applicationId,
    supportedChains,
  }: {
    applicationId: string;
    supportedChains: number[];
  }): Promise<AxiosResponse<void, void>> =>
    Api.post(`${WalletConfigAPI.baseURL}/${applicationId}`, {
      supportedChains,
    });
}

export default WalletConfigAPI;
